import React from 'react';
import { format } from 'date-fns';
import { StorageHistoryEntry, HistoryActionType } from '../types/customer';
import { formatPlateForDisplay } from '../utils/plateFormatter';

const historyBadges: Record<HistoryActionType, { label: string; color: string }> = {
  'olusturma': { label: 'Girdi', color: '#16a34a' },
  'guncelleme': { label: 'Güncellendi', color: '#2563eb' },
  'silme': { label: 'Teslim/Silindi', color: '#dc2626' },
  'geri-alma': { label: 'Geri Alındı', color: '#d97706' },
};

interface Props {
  entries: StorageHistoryEntry[];
  loading?: boolean;
  error?: boolean;
}

const HistoryList: React.FC<Props> = ({ entries, loading = false, error = false }) => {
  if (loading) return <div className="loading">Yükleniyor...</div>;
  if (error) return <div className="error-message">Geçmiş yüklenemedi</div>;
  if (entries.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
        Geçmiş kaydı yok
      </div>
    );
  }

  return (
    <div>
      {entries.map((entry) => {
        const badge = historyBadges[entry.islemTipi] || { label: entry.islemTipi, color: '#6b7280' };
        const snap = entry.snapshot || {};
        return (
          <div
            key={entry._id}
            style={{ padding: '8px 0', borderBottom: '1px solid #e5e7eb', fontSize: '0.85rem' }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#6b7280' }}>
                {format(new Date(entry.islemZamani), 'dd.MM.yyyy HH:mm')}
              </span>
              <span
                style={{
                  background: badge.color,
                  color: '#fff',
                  borderRadius: '4px',
                  padding: '1px 8px',
                  fontSize: '0.75rem',
                }}
              >
                {badge.label}
              </span>
              <span>
                {[snap.marka, snap.ebat].filter(Boolean).join(' ')} · {snap.adet ?? '-'} adet
                {entry.plaka ? ` · ${formatPlateForDisplay(entry.plaka)}` : ''}
              </span>
              {entry.islemYapan && (
                <span style={{ color: '#6b7280', marginLeft: 'auto' }}>{entry.islemYapan}</span>
              )}
            </div>
            {entry.islemTipi === 'guncelleme' && entry.onceki && (
              <div style={{ color: '#6b7280', fontSize: '0.8rem', marginTop: '2px' }}>
                önceki: {[entry.onceki.marka, entry.onceki.ebat].filter(Boolean).join(' ')}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HistoryList;
